<template>
  <v-btn class="primary"
         block
         rounded
         style="font-weight: 700"
         large
         :disabled="disabled"
         :loading="missionsLoading">
    <span class="pr-2">
      <slot></slot>
    </span>
    <svg style="width: 50px;"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 25 100 50">
      <circle fill="#fff"
              cx="16.1"
              cy="50"
              r="8.3"
              class="undefined"/>
      <circle fill="#fff"
              cx="44.4"
              cy="50"
              r="10.9"
              class="undefined"/>
      <path fill="#fff"
            d="M91 47.9L69.7 35.6c-1.6-0.9-3.6 0.2-3.6 2.1v24.6c0 1.9 2 3 3.6 2.1L91 52.1C92.6 51.2 92.6 48.8 91 47.9z"
            class="undefined"/>
    </svg>
  </v-btn>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('patientMissions', [
        'missionsLoading',
      ]),
    },

    props: {
      disabled: {
        required: false,
        type: Boolean
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .FinishMissionButtonBlock {

  }
</style>
